import { all, call } from "redux-saga/effects"

import { listFetchingFlow } from "./list"

export default function* coursesSaga() {
  yield all([call(listFetchingFlow)])
}
